import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { DocumentDownloadOptions } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface ExportKimToWordParams {
  title: string;
  messageId: string;
  artifactId?: string;
  artifactVersionNumber?: number;
  options?: Partial<DocumentDownloadOptions>;
}

export const useExportKimToWord = (matterId?: string, subsetId?: string, threadId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation(
    async ({ title, messageId, artifactId, artifactVersionNumber, options }: ExportKimToWordParams) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: {
          title,
          messageId,
          ...(artifactId && { artifactId }),
          ...(artifactVersionNumber !== undefined && { artifactVersionNumber }),
          ...(options && { options }),
        },
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/export`,
        fetchConfig,
      );

      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${title}.docx`;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    {
      onError: () => {
        toast.error('Failed to download as Word document');
      },
    },
  );
};
